export const EVENTS_ACTIONS = {
  FETCH_EVENTS: 'EVENTS/FETCH_EVENTS',
  FETCH_EVENTS_SUCCESS: 'EVENTS/FETCH_EVENTS_SUCCESS',
  FETCH_EVENTS_ERROR: 'EVENTS/FETCH_EVENTS_ERROR',
};
